module.exports = __webpack_public_path__ + "media/images/recruitment/promo-products-image-bc14ea7e4f935faebf9778f7c3f5d34b.png";